<template>
  <div>
    <SearchNavHeader :currentPage="'searchStores'"/>
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-md-8 col-lg-6 mx-auto">
      <div class="row mt-4">
        <div class="col-12 text-center">
          <v-combobox
              v-if="showSearchBox"
              v-model="searchKeyWord"
              append-icon="far fa-search"
              class="rounded-lg search-combobox"
              dense
              flat
              :items="storeItems"
              hide-details
              placeholder="جستجو در فروشگاه ها..."
              solo
              @click:clear="removeSearchHistory"
              @keyup="search($event)"
              @click:append="searchBtn"></v-combobox>

          <span v-else class=" rounded-xl bg-white py-2 px-3 d-inline-block position-relative">
             {{ searchKeyWord }}
             <v-btn class=" pl-1 close-search-key-btn" icon small @click="removeSearchKeyword"><i
                 class="fa-regular fa-circle-xmark pointer font16px "></i></v-btn>
          </span>
        </div>
      </div>
      <div class="min-height-300px">
      <div class="row">
        <div v-if="!hasResult" class="col-12 text-center">
          نتیجه ای یافت نشد
        </div>
        <div v-else v-for="item in stores" :key="item.id" class="col-4 p-1 col-lg-3">
          <StoreCard :item="item"/>
        </div>
      </div>
      </div>
        </div>
      </div>
    </div>
    <v-overlay :value="showLoaderDialog">
      <div class="loading-spinner">
      </div>
    </v-overlay>
  </div>
</template>

<script>
import SearchNavHeader from "@/views/Search/SearchNavHeader";
import StoreCard from "@/components/StoreCard";

export default {
  name: "SearchStores",
  metaInfo: {
    title: 'ایوان خانه- جستجوی فروشگاه',
  },
  components: {StoreCard, SearchNavHeader},
  data: () => ({
    showLoaderDialog: false,
    storeItems: [],
    showSearchBox: true,
    searchKeyWord: null,
    stores: [],
    hasResult:true
  }),
mounted() {
    this.getVipStores()
    this.getAllStores()
},
  methods: {
    search(e) {
      if (e.keyCode === 13) {
        this.searchBtn()
      }
    },
    searchBtn() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("pageIndex", 1);
      urlencoded.append("pageSize", "10000");
      urlencoded.append("KeyWord", this.searchKeyWord);


      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "SearchEngine/_ListVendor", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.stores = (json.VendorViewModel)
            this.showLoaderDialog = false
            this.showSearchBox = false
           this.hasResult = json.TotlalCount !== 0;

          })
          .catch(error => console.log('error', error));
    },
    getVipStores(){
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("pageIndex", '1');
      urlencoded.append("pageSize", '50');
      urlencoded.append("IsVipBrand", 'true');



      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "SearchEngine/_ListVendor", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.stores = (json.VendorViewModel)
            this.showLoaderDialog = false
            this.hasResult = json.TotlalCount !== 0;

          })
          .catch(error => console.log('error', error));
    },
    getAllStores(){
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("pageIndex", '1');
      urlencoded.append("pageSize", '20000');


      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "SearchEngine/_ListVendor", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            let stores = json.VendorViewModel
            let storeItems =[]
           for(let i =0 ;i<stores.length;i++){
            storeItems.push(stores[i].Name)
           }
           this.storeItems = storeItems

          })
          .catch(error => console.log('error', error));
    },
    removeSearchKeyword() {
      this.showSearchBox = true
      this.searchKeyWord = null
      this.stores = []
    },
    removeSearchHistory(){
      this.showSearchBox = true
      this.searchKeyWord = null
      this.stores = []
    }
  }

}
</script>
